import { h, Component } from 'preact';
import { Link } from 'preact-router/match';
import { Text } from 'preact-i18n';

import store from '../../store';

import ServiceWrapper from './serviceWrapper'

export default  class aService extends Component {
	render() {
		return (<ServiceWrapper {...this.props}>
						<article class="has-widget">
							<p>Papildus DolphNet pakalpojumiem ir iespējams arī iegādāties dažādas telekomunikāciju iekārtas par izdevīgām cenām.</p>
							<h2>Pieejamās iekārtas</h2>
							<ul>
								<li>Grandstream IP telefoni</li>
								<li>Bezvadu rūteri</li>
								<li>Tīkla komutatori (Ubiquiti, Edge-core, Netgear)</li>
								<li>Maršrutētāji (Mikrotik, Ubiquiti u.c)</li>
								<li>Serveri un datu masīvi</li>
							</ul>
							<p>Lai uzzinātu vairāk par pieejamajamajām iekārtām, <Link href={store.prefix+'/contact?service=equipment&form=true'}>sazinieties ar mums</Link>. </p>
						</article>
						<div class="widget plan">

						     <ul class="bullet">
						     	<li>Visai tehnikai pirmo gadu bezmaksas tehniskais atbalsts</li>
						     	<li>Atkarībā no iekārtas veida, pieejama bezmaksas uzstādīšana</li>
						     </ul>
						     <div><Link href={store.prefix+'/contact?service=equipment&form=true'} class="button"><Text id="email.widget.list.btn"/></Link></div>
						</div>
				</ServiceWrapper>);
	}
}



// WEBPACK FOOTER //
// ./routes/services/equipment.js